import React from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import { Map } from 'immutable';
import * as MaterialUI from 'material-ui';
import { Container, Row, Col } from 'reactstrap';
import { OverlayView } from 'react-google-maps';

import { GMapsC } from 'modules/general/component';
import * as generalActions from 'modules/general/action';
import * as mapaGenActions from '../action';
import * as viajesActions from 'modules/viajes/action';

@connect(store => ({
  viajes: store.getIn(['viajes', 'hoy']),
  viajeSelected: store.getIn(['mapaGeneral', 'viajeSelected']),
}))
export default class extends React.Component {
  constructor(props) {
    super(props);
  }
  componentDidMount() {
    this.props.dispatch(generalActions.dashboard_changeTitle('MAPA'));
    this.props.viajes.size == 0 && this.props.dispatch(viajesActions.get());
  }
  componentWillReceiveProps = newProps => {
    if (
      newProps.userRoles &&
      this.props.userRoles != newProps.userRoles &&
      newProps.userRoles.find(v => v == 'admin' || v == 'devAdmin' || v == 'administrador_viajes' || v == 'ver_viajes' || v == 'administrador_reservas')
    )
      this.props.dispatch(viajesActions.get());
  };
  onMarkerClick(viajeId) {
    this.props.dispatch(mapaGenActions.setState({ viajeSelected: this.props.viajeSelected == viajeId ? null : viajeId }));
  }
  handleExpandChange(viajeId) {
    this.props.dispatch(mapaGenActions.setState({ viajeSelected: this.props.viajeSelected == viajeId ? null : viajeId }));
  }
  render() {
    const { viajes, viajeSelected } = this.props;
    return (
      <Container style={{ flex: 1, width: '100%', height: '100%' }}>
        <GMapsC
          listaUbicaciones={viajes.filter(viaje => viaje.get('_localizacion') && viaje.get('_localizacion').size > 0)}
          mapElement={<div style={{ height: screen.availHeight - 120 - 106 }} />}
          containerElement={<div style={{ flex: 1 }} />}
          markerClick={id => this.onMarkerClick(id)}
        />

        <Row style={{ position: 'absolute', top: 70, right: 40, zIndex: 99 }}>
          {viajes.map((viaje, i) => {
            if (viaje.get('_localizacion') && viaje.get('_localizacion').size > 0) {
              let velocidad = viaje.get('velocidad'),
                lastMod = viaje.getIn(['_localizacion', 0, 'fechaEnviado']) ? moment(viaje.getIn(['_localizacion', 0, 'fechaEnviado'])) : null,
                chofer = viaje.getIn(['_chofer', 'nombre']);
              return (
                <MaterialUI.Card key={i} expanded={viaje.get('id') == viajeSelected} onExpandChange={() => this.handleExpandChange(viaje.get('id'))} style={{ marginTop: 5 }}>
                  <MaterialUI.CardHeader showExpandableButton title={viaje.getIn(['_trayecto', 'nombre'])} />
                  <MaterialUI.CardText expandable style={{ paddingTop: 0, paddingBottom: 0, marginTop: 0, marginBottom: 0 }}>
                    Reservas: {viaje.get('cantReservas')}/{viaje.get('cantAsientos')}
                  </MaterialUI.CardText>
                  <MaterialUI.CardText expandable style={{ paddingTop: 0, paddingBottom: 0, marginTop: 0, marginBottom: 0 }}>
                    Horario: {moment(viaje.get('horario')).format('HH:mm')}
                  </MaterialUI.CardText>
                  {velocidad && (
                    <MaterialUI.CardText expandable style={{ paddingTop: 0, paddingBottom: 0, marginTop: 0, marginBottom: 0 }}>
                      {' '}
                      Velocidad: {velocidad.toFixed(2)} km/h{' '}
                    </MaterialUI.CardText>
                  )}
                  {chofer && (
                    <MaterialUI.CardText expandable style={{ paddingTop: 0, paddingBottom: 0, marginTop: 0, marginBottom: 0 }}>
                      {' '}
                      Chofer: {chofer}{' '}
                    </MaterialUI.CardText>
                  )}
                  {lastMod && (
                    <MaterialUI.CardText expandable style={{ paddingTop: 0, paddingBottom: 0, marginTop: 0, marginBottom: 0 }}>
                      {' '}
                      Ultima actualizacion: {lastMod.format('HH:mm')} hs{' '}
                    </MaterialUI.CardText>
                  )}
                </MaterialUI.Card>
              );
            }
          })}
        </Row>
      </Container>
    );
  }
}



// WEBPACK FOOTER //
// src/modules/mapaGeneral/components/mapa.js